import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PatternSales } from "../types/backend-generated/PatternSales";
import { formatCentsNOK } from "../utils/currencyFormat";
import Sales from "./Sales";
import styles from "./SalesOverview.module.css";
import { filterPatternSales, findTotalPatternSaleSum } from "./SalesUtils";

const PatternSaleOverview = ({
  patternSales,
  month,
  year,
}: {
  patternSales: PatternSales;
  month: number;
  year: number;
}) => {
  const { patternId, title, sales } = patternSales;
  const [expanded, setToExpand] = useState(false);
  const [theseSales, numberOfSales] = filterPatternSales(sales, month, year);
  const totalSum = findTotalPatternSaleSum(theseSales);
  const { t } = useTranslation();

  const expandRow = () => {
    setToExpand(!expanded);
  };

  return (
    <div>
      <div className={styles.patternRow}>
        <div className={styles.tableItem}>{title}</div>
        <div className={styles.tableItem}>{patternId}</div>
        <div className={styles.tableItemSales}>{numberOfSales}</div>
        <div className={styles.tableItemSum}>{formatCentsNOK(totalSum)}</div>
        <button className={styles.expandButton} onClick={expandRow}>
          {expanded ? t("sales.hide_details") : t("sales.show_details")}
        </button>
      </div>
      {expanded && <Sales sales={theseSales} />}
    </div>
  );
};

export default PatternSaleOverview;
